import { useState } from "react";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { ferr, Modal } from "./shared";

export default function ChangePasswordModal({ onClose }) {
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return toast.error("New password must be at least 8 characters.");
    if (f.next !== f.confirm) return toast.error("New passwords don't match.");
    setBusy(true);
    try {
      await api.post("/admin/change-password", { current_password: f.current, new_password: f.next });
      toast.success("Password updated.");
      onClose();
    } catch (e) { ferr(e, "Couldn't change password."); } finally { setBusy(false); }
  };

  return (
    <Modal title="Change your password" onClose={onClose}>
      <form onSubmit={submit} className="space-y-3" data-testid="admin-cp-form">
        <p className="text-[13px] text-mortar flex items-center gap-1.5"><KeyRound size={14} /> Update the password for your console account.</p>
        <div>
          <label className="label-mtr">Current password</label>
          <input type="password" className="input-mtr" required value={f.current} onChange={(e) => setF({ ...f, current: e.target.value })} data-testid="admin-cp-current" />
        </div>
        <div>
          <label className="label-mtr">New password <span className="text-mortar normal-case">(min 8)</span></label>
          <input type="password" className="input-mtr" required minLength={8} value={f.next} onChange={(e) => setF({ ...f, next: e.target.value })} data-testid="admin-cp-new" />
        </div>
        <div>
          <label className="label-mtr">Confirm new password</label>
          <input type="password" className="input-mtr" required value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} data-testid="admin-cp-confirm" />
        </div>
        <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="admin-cp-submit">
          {busy ? <Loader2 className="animate-spin" size={18} /> : "Update password"}
        </button>
      </form>
    </Modal>
  );
}
